// REQ1956 checked
var language = {
  rapportage_historische_statusovergangen: "Report historical status changes",
  yes: "Yes",
  no: "No",
  no_records_found: "No records are found",
  next: "Next",
  previous: "Previous",
  first: "First",
  last: "Last",
  show: "Show",
  records: "records",
  total_number_of_records: "Total number of records",
  filtered_from: "filtered from",
  all: "All",
  no_values: "No values",
  from: "From",
  till: "Until",
  select_all: "Select all",
  clear: "Clear",
  filter: "Filter",
  filteren: "Filter",
  more: "more",
  less: "less",
  default_value: "Default value",
  values: "Values",
  apply: "Apply",
  close: "Close",
  add_participants_to_test_cycle_title: 'Add participants',
  add_participants_to_test_cycle: 'Do you want to add participants to the test cycle now? (you can also do this later)',
  delete_sso_confirm_title: "Are you sure that you want to delete this configuration?",
  delete_sso_confirm_message: "This action cannot be reverted.",
  page_warning_onclosing:
    "Are you sure to close the page? Unsaved changes will be lost!",
  lightbox_warning_onclosing:
    "Are you sure to close the lightbox? Unsaved changes will be lost!",
  selected_only_one_row_to_copy: "Select exactly one row to copy",
  select_one_testcase_to_create_testruns:
    "Select the testcases which you want to create testruns for",
  select_one_testscenario_to_create_testruns:
    "Select the testscenario's which you want to create testruns for",
  selected_only_one_row_to_create_test_runs:
    "Select exactly one row to create testruns",
  no_comments_are_selected_to_remove: "Select at least one comment to delete",
  no_environments_are_selected_to_add_to_user:
    "Select at least one environment to add to the user.",
  this_item_does_not_exist_anymore: "This item does not exist (anymore)",
  no_rows_are_selected_to_relate: "Select at least one defect to link",
  no_rows_are_selected_to_add: "Select at least one row to add",
  no_rows_are_selected_to_send_login: "First select the users you want to send an email with login credentials",
  no_rows_are_selected_to_remove: "Select at least one row to remove",
  no_defects_are_selected_to_remove: "Select at least one defect to remove",
  no_rows_are_selected_to_clear_tester:
    "Select at least one row to clear the tester field",
  no_rows_are_selected_to_reset_testrun_testcase_step_statuses:
    "Select at least one row to reset the test case status",
  no_rows_are_selected_to_archive: "Select at least one row to archive",
  no_rows_are_selected_to_unarchive: "Select at least one row to unarchive",
  no_rows_are_selected_to_bulk_edit:
    "Select at least one row for the bulk edit",
  bulk_edit_items_not_possible_because_of_jira_links:
    "The bulk edit cannot take place because one or more items are linked to a Jira issue.",
  bulk_edit_requirements_not_possible_because_of_jira_links:
    "The bulk edit cannot take place because one or more requirements are linked to a Jira issue.",
  bulk_edit_defects_not_possible_because_of_jira_links:
    "The bulk edit cannot take place because one or more defects are linked to a Jira issue.",
  bulk_edit_defects_not_possible_because_of_integration_links:
    "The bulk edit cannot take place because you have selected defects which are linked to an external system.",
  bulk_edit_requirements_not_possible_because_of_integration_links:
    "The bulk edit cannot take place because you have selected requirements which are linked to an external system.",
  no_testruns_are_selected_to_schedule:
    "Select at least one test run to schedule.",
  no_users_are_selected_to_add_to_environment:
    "Select at least one user to add to the environment.",
  no_users_are_selected_to_remove_from_environment:
    "Select at least one user to remove from the environment.",
  select_one_or_more_users_to_remove_from_test_cycle:
    "Select one or more users to remove from the test cycle.",
  select_one_or_more_usergroups_to_remove:
    "Select one or more usergroups to remove.",
  select_one_or_more_usergroups_to_remove_from_test_cycle:
    "Select one or more usergroups to remove from the test cycle.",
  select_one_or_more_users_to_add_to_group:
    "Select one or more users to add to the group.",
  select_one_or_more_users_to_remove_from_group:
    "Select one or more users to remove from the group.",
  select_one_or_more_usergroups_to_add_to_testcycle:
    "Select one or more groups to remove from the test cycle.",
  select_one_or_more_user_or_group_to_add_to_testcycle:
    "Select at least one user or group to add to the test cycle.",
  select_one_or_more_attachments_to_remove:
    "Select one or more attachments to remove",
  select_one_or_more_sprints_to_continue:
    "Select one or more sprints to continue",
  select_one_or_more_user_stories_to_continue:
    "Select one or more user stories to continue",
  jira_user_story_selection_limit_reached:
    "You have exceeded the limit of 50 selected items. Please deselect some items before proceeding.",
  are_you_sure_you_want_to_remove_selected_usergroups:
    "Are you sure want to remove the selected usergroup(s)?",
  are_you_sure_you_want_to_remove_selected_usergroups_from_test_cycle:
    "Are you sure you want to remove the selected usergroup(s) from the test cycle?",
  are_you_sure_you_want_to_remove_selected_users_from_test_cycle:
    "Are you sure you want to remove the selected users from the test cycle?",
  are_you_sure_you_want_to_remove_selected_attachments:
    "Are you sure you want to remove the selected attachment(s)?",
  are_you_sure_you_want_to_remove_selected_users_from_group:
    "Are you sure you want to remove the selected users from the group?",
  are_you_sure_you_want_to_remove_selected_comments:
    "Are you sure you want to remove the selected comments?",
  are_you_sure_you_want_to_remove_this_defect:
    "Are you sure you want to remove this defect?",
  are_you_sure_you_want_to_remove_this_task:
    "Are you sure you want to delete this task?",
  are_you_sure_you_want_to_remove_the_users_from_the_environment:
    "Are you sure you want to remove the user(s) from the environment?",
  are_you_sure_you_want_to_add_the_users_to_the_environment:
    "Are you sure you want to add the user(s) to the environment?",
  are_you_sure_to_archive: "Are you sure you want to archive these row(s)?",
  are_you_sure_to_unarchive: "Are you sure you want to unarchive these row(s)?",
  are_you_sure_to_clear_tester:
    "Are you sure you want to clear the field 'Tester' for these row(s)?",
  are_you_sure_you_want_to_reset_testrun_testcase_step_statuses:
    "Are you sure you want to clear the status of the selected test case(s)?",
  are_you_sure_you_want_to_reset_tiles_of_test_cycles_as_manager:
    "Are you sure you want to reset all tiles in the test cycles of which you are test manager to the standard Testersuite tiles?",
  are_you_sure_you_want_to_reset_tiles_of_test_cycles_as_participant:
    "Are you sure you want to reset all tiles in the test cycles of which you are a participant to the standard Testersuite tiles?",
  are_you_sure_to_remove: "Are you sure you want to remove these row(s)?",
  defects_will_be_unlinked_from_testrun:
    "ATTENTION: one or more test cases have defects to them, these defects will be unlinked from the test run. Are you sure you want to remove these row(s)?",
  are_you_sure_to_cancel: "Are you sure you want to cancel?",
  are_you_sure_to_cancel_force_defects:
    "The status of the test case step will remain the same, because you haven't created a defect. Are you sure you want to close this defect?",
  connect_defects_closing_without_changing_status:
    "The status of the test case step will remain the same, because no new open defect has been selected",
  new_defect_closing_without_changing_status:
    "The status of the test case step will remain the same, because the new defect has been closed immediately",
  are_you_sure_to_deleted_this_item:
    "Are you sure you want to remove this item?",
  are_you_sure_remove_test_cycle:
    "Are you sure you want to delete this test cycle? Removing it will remove all the underlying items. Removing may take a while, please be patient.",
  are_you_sure_you_want_to_make_yourself_developer_of_defect:
    "Are you sure you want to make yourself developer of this defect?",
  are_you_sure_you_want_to_cancel_adding_an_image:
    "Are you sure you want to cancel adding an image?",
  are_you_sure_you_want_to_cancel_editing_the_image:
    "Are you sure you want to cancel editing the image?",
  are_you_sure_you_want_to_delete_the_attachment:
    "Are you sure you want to delete the attachment?",
  are_you_sure_you_want_to_delete_this_step:
    "Are you sure you want to delete this step?",
  are_you_sure_you_want_to_delete_the_selected_defects:
    "Are you sure you want to delete the selected defect(s)",
  are_you_sure_you_want_to_delete_this_product_with_children:
    "Any child products and/or requirements will be deleted as well! Are you sure you want to continue deleting?",
  are_you_sure_you_want_to_delete_this_requirement:
    "Are you sure you want to delete this requirement?",
  are_you_sure_you_want_to_delete_this_report:
    "Are you sure you want to delete this report?",
  continue_to_remove_tiles_from_other_test_cycles_where_you_are_manager:
    "You are deleting a standard tile. The tile will be deleted from all test cycles of which you are the manager. Would you like to continue?",
  continue_to_remove_tiles_from_other_test_cycles_where_you_are_participant:
    "You are deleting a standard tile. The tile will be deleted from all test cycles of which you are a participant. Would you like to continue?",
  uncheck_show_tile_in_all_test_cycles_manager:
    "When a tile is no longer a standard tile, the tile will be deleted from all test cycles of which you are the manager.",
  uncheck_show_tile_in_all_test_cycles_participant:
    "When a tile is no longer a standard tile, the tile will be deleted from all test cycles of which you are a participant.",
  riskmatrix_change: "Chance of failure",
  riskmatrix_damage: "Damage",
  validationerror_mandatory: "Not all required fields are filled.",
  validationerror_passwordcheck: "The two entered passwords are not equal.",
  validationerror_passwordvalid:
    "The password does not meet the minimum requirements.",
  validationerror_usernamecheck: "The username is already in use.",
  validationerror_emailvalid: "The entered email address is not valid.",
  validationerror_max_length_reached: "The value in the textfield is too long",
  validationerror_nonnegativeint:
    "The number of days should be a whole, positive number",
  search_missing_searchterm: "Fill in a search term",
  mailer_noselected_emailaddress: "Select at least one email address",
  mailer_missing_emailaddress: "Enter at least one email address",
  mailer_missing_message: "Enter a message for the receiver",
  button_not_authorized: "You are not authorized to perform this function",
  button_not_available: "This function is not available",
  customization_fieldnamemandatory:
    "Enter both translations of the field name.",
  fill_all_empty_translation_values: "Enter all values to continue.",
  please_make_the_field_visible_first: "Please make the field visible first.",
  datatableExplanation_1: "Filtering and sorting in the data table:",
  datatableExplanation_2:
    "<ul><li>Sort on a column by clicking on the column title</li>",
  datatableExplanation_3:
    "<li>Enter a search query above the column name and click on the filter button next to the column</li>",
  datatableExplanation_4:
    "<li>Usage of special characters to refine filtering:",
  datatableExplanation_5:
    "<ul><li>Search query: *sap returns results that end with sap</li>",
  datatableExplanation_6:
    "<li>Search query: sap* returns results that start with sap</li>",
  datatableExplanation_7:
    '<li>Search query: "sap" returns results with exactly sap</li></ul></ul></li></ul>',
  datatable_autoselect_children: "Automatically select and deselect",
  datatable_autoselect_children_explanation:
    "When the checkbox is checked the underlying products and requirements will be selected automatically.",
  testrun_confirm_overwrite_original_testcase:
    "The test case in the test run will be saved. Would you like to make the adjustments in the original test case in the Test design module?",
  testrun_confirm_remove_relation_with_defects:
    "ATTENTION: there are defects linked to some of the items you want to remove. When you remove these items, the relations with these defects will be removed. Do you want to continue?",
  testrun_confirm_autofill_testers:
    "Do you want to auto fill the tester column?",
  testruntestcasestep_confirm_remove_relation_with_defects:
    "ATTENTION: there are defects linked to the step you want to remove. When you remove this step, the relations with these defects will be removed. Do you want to continue?",
  masterlist_pull_confirm_execution:
    "Are you sure you want to transfer the selected items to the test cycle?",
  masterlist_push_confirm_execution:
    "Are you sure you want to transfer the selected items to the Masterlist?",
  entity_version_process_confirm:
    "Are you sure you want to overwrite the Masterlist version with the version from this test cycle (including all attachments and comments)?",
  test_scenario_version_process_confirm:
    "Are you sure you want to overwrite the Masterlist version with the version from this test cycle (including all attachments and comments)?" +
    "\n" +
    "\n" +
    "Notice: the test cases that belong to this test scenario will also be updated in the Masterlist!",
  topbar_masterlist: "Masterlist",
  topbar_testcycle: "Test cycle",
  topbar_products: "Products",
  topbar_products_new: "New product",
  topbar_requirements: "Requirements",
  topbar_requirements_new: "New requirement",
  topbar_archived: "Archived",
  move_defects: "Are you sure you want to move the defect(s) to test cycle",
  no_rows_are_selected_to_move: "Select at least one defect to move",
  blocking: "blocking",
  test_run_status_ok: "OK",
  test_run_status_notok: "Not OK",
  test_run_status_started: "Started",
  test_run_status_notstarted: "Not started",
  test_run_status_skipped: "Overgeslagen",
  cancel_copy_product:
    "Are you sure you want to cancel copying the product? (the copy will be deleted)",
  cancel_copy_requirement:
    "Are you sure you want to cancel copying the requirement? (the copy will be deleted)",
  cancel_copy_test_scenario:
    "Are you sure you want to cancel copying the test scenario? (the copy will be deleted)",
  cancel_copy_test_case:
    "Are you sure you want to cancel copying the test case? (the copy will be deleted)",
  cancel_copy_failed: "Het verwijderen van de kopie is mislukt.",
  package_limit_exceeded_confirm_message:
    "You have reached the maximum amount of active users. When you create more active users additional charges will be applied. Do you want to proceed?",
  new_environment_content_share_warning:
      "When you start working in a new environment, you cannot transfer the data in that environment to other environments. Do you want to continue creating a new environment?",
  no_rows_are_selected_to_add_to_testscenario:
    "Select at least one item to add to the test scenario",
  remove_test_case_step: "Are you sure you want to remove this step?",
  successfully_processed_to_masterlist:
    "Process to Masterlist successful. <br><br>Set test cycle status to 'Processed in masterlist'?",
  successfully_processed_to_testcycle: "Process to test cycle successful",
  push_modal_message:
    "The selected items are being processed to the Masterlist. This may take a while...",
  pull_modal_message:
    "The selected items are being pulled from the Masterlist. This may take a while...",
  modal_push_header: "Processing to Masterlist",
  modal_pull_header: "Pulling from Masterlist",
  confirm_push_to_jira: "Are you sure you want to push this defect to Jira?",
  confirm_push_to_azure:
    "Are you sure you want to push this defect to Azure DevOps?",
  confirm_pull_requirements_from_azure:
      "Do you want to retrieve the open product backlog items / user stories from the linked Azure DevOps project and area path?</p><p>A maximum of 50 work items are retrieved at a time.",
  detached_from_azure:
    "The defect has been unlinked from the Azure DevOps work item because it was not found in the project that is linked to this test cycle",
  defect_remove_rule: "Are you sure you want to remove this rule?",
  defect_remove_rule_header: "Remove rule?",
  test_scenario_is_in_test_run:
    "This test scenario is included in the test run",
  test_case_is_in_test_run: "This test case is included in the test run",
  test_run_add_test_case_select_at_least_one_test_case:
    "Select at least one test case to add to the test run.",
  test_run_test_case_step_has_been_deleted_cant_change_status:
    "This step has been deleted while you were executing the test run.",
  testrun_add_test_test_scenario_no_selection:
    "Select at least one test scenario to add to the test run.",
  testrun_remove_copy:
    "Are you sure you don't want to copy the test run (the copy will be deleted)?",
  step_attachments_lightbox_title: "Attachments for step",
  step_actual_result_attachments_lightbox_title: "Result attachments for step",
  bulk_edits_for: "Bulk edit for selected",
  test_cases: "test cases",
  test_scenarios: "test scenarios",
  products: "products",
  requirements: "requirements",
  testruns: "testruns",
  test_cycles: "test cycles",
  users: "users",
  defects: "defects",
  save: "Save",
  bulk_edit_no_checkbox_selected: "Select at least on field to change",
  execute: "Execute",
  bulk_edit_confirm:
    "Are you sure you want to execute the bulk edit for the selected items?",
  test_run_schedule_confirm:
    "Are you sure you want to execute the edit for the selected test runs?",
  tree_picker_title: "Product/requirement selection",
  tree_picker_title_without_requirement: "Product selection",
  version_remove: "Are you sure you want to remove the selected version(s)?",
  view: "View",
  following_steps: "The following open defects are related to this test step:",
  testcase_step_defects_are_open: "Open defects are related to this step.",
  would_you_like_to_close:
    "Would you like to close these defects (status to Solved)?",
  would_you_like_to_close_open_defects:
    "There are open defects connected to some steps. Would you like to close these defects (set status to Solved)?",
  would_you_like_to_close_step_open_defects:
    "There are open defects connected to this step. Would you like to close these defects (set status to Solved)?",
  close_defects_title: "Close open defects?",
  no_rows_are_selected_to_connect_to_test_run:
    "Select at least one defect to connect.",
  add_note: "Add note",
  add: "Add",
  edit: "Edit",
  status_rules_defect_title: "Email notifications for defects",
  status_rules_requirement_title: "Email notifications for requirements",
  status_rules_testcase_title: "Email notifications for test cases",
  status_rules_testscenario_title: "Email notifications for test scenarios",
  requirement_mail_title: "Email requirement",
  defect_mail_title: "Mail defect",
  getting_started_title: "Getting started",
  getting_started_watch_video: " Watch video (3 minutes)",
  dialog_send_login: "Send login data",
  dialog_delete: "Delete",
  dialog_add: "Add",
  dialog_move: "Move",
  dialog_push: "Push",
  dialog_pull_from_azure: "Retrieve",
  dialog_reset: "Reset",
  dialog_autofill: "Autofill",
  dialog_overwrite: "Overwrite",
  dialog_continue: "Continue",
  dialog_archive: "Archive",
  dialog_unarchive: "Unarchive",
  dialog_bulk_edit: "Bulk edit",
  dialog_additional_costs: "Additional costs!",
  dialog_change_status: "Change status",
  dialog_ok: "OK",
  dialog_close: "Close",
  dialog_cancel: "Cancel",
  dialog_notification: "Notification",
  dialog_connect_defects: "Connecting defects",
  dialog_warning: "Warning",
  dialog_error: "Error",
  dialog_error_occurred: "An error occurred. Please try again later.",
  dialog_error_occurred_while_saving_export_settings:
    "An error occurred while saving the export settings.",
  dialog_start_import_header: "Start import",
  dialog_start_import_message:
    "You are about to start the import process. Are you sure you want to continue?",
  dialog_assign_to_yourself: "Assign to yourself",
  dialog_processing_title: "Processing",
  dialog_processing_message: "Currently processing. This may take a while...",
  creating_test_cycle_and_importing_selected_jira_user_stories:
    "Creating a test cycle and importing the selected JIRA user stories.<br />This may take a while...",
  synchronizing_data_with_jira_issue: "Updating related JIRA issues",
  synchronizing_data_with_azure_issue: "Updating related Azure DevOps issues",
  import_entities_from_azure:
      "Azure Devops work items are being retrieved.<br />This may take a while...",
  importing_selected_jira_user_stories:
    "Importing the selected JIRA user stories.<br />This may take a while...",
  dialog_create_a_new_defect: "Create a new defect",
  dialog_defects: "Defects",
  dialog_remove_defect: "Delete defect",
  dialog_close_connected_open_defects: "Close open defects",
  dialog_delete_tile_from_other_test_cycles:
    "Delete tile from other test cycles",
  cancel: "Cancel",
  import_example_download_filename: "Testersuite import",
  attachment: "Attachment",
  attachments: "Attachments",
  attachment_upload_failed:
    "An error occurred while uploading the attachment. Try a smaller filesize or a different file format.",
  set_columns: "Set columns",
  reset_column_settings: "Reset settings",
  reset_tiles: "Reset tiles",
  columns_will_be_reset: "The columns will be reset to the default layout.",
  visible: "Visible",
  invisible: "Invisible",
  no_active_testcycle_create_one:
    "You are not yet a participant of an active test cycle. Click 'Test cycles' to open an existing or start a new test cycle.",
  no_active_testcycle_ask_to_join_one:
    "You are not yet a participant of an active test cycle. Click 'Test cycles' to open an existing or ask a test cycle owner to make you a participant.",
  file_being_uploaded: "Waiting for file upload to be completed",
  clipboard_does_not_contain_a_valid_image:
    "Your clipboard does not contain a (valid) image.",
  file_is_not_an_image: "This file is not an image.",
  image_editor_mouse: "Mouse/Move",
  image_editor_rectangle: "Rectangle",
  image_editor_ellipse: "Ellipse",
  image_editor_line: "Straight line",
  image_editor_arrow: "Arrow",
  image_editor_pencil: "Pencil",
  image_editor_text: "Text",
  image_editor_anonimize: "Anonimize",
  image_editor_trash: "Delete selection",
  image_editor_clear: "Delete image",
  image_editor_clear_canvas_objects: "Reset",
  image_editor_paste: "paste",
  image_editor_drag: "drag",
  image_editor_drop: "Let go of your mouse button",
  image_editor_or: "or",
  image_editor_browse: "browse",
  image_editor_filename_input_placeholder: "Filename (optional)",
  file_catcher_paste: "paste",
  file_catcher_drag: "drag",
  file_catcher_drop: "Let go of your mouse button",
  file_catcher_or: "or",
  file_catcher_browse: "browse",
  file_catcher_uploading: "Uploading...",
  edit_image: "Edit",
  editing_image: "Editing image",
  loading: "Loading...",
  clipboard_does_not_contain_a_valid_screenshot:
    "Your clipboard does not contain a (valid) screenshot.",
  drag_valid_files_into_the_area: "Drag (valid) files into the box.",
  drag_one_valid_file_into_the_area: "Drag one (valid) file into the box.",
  jira_no_user_story_selected_to_create_test_cycle_with:
    "Select at least one user story to create a test cycle with.",
  copy_test_cycle_waiting_header: "Copying",
  copy_test_cycle_waiting_message:
    "Copying the test cycle, this may take a few minutes.",
  copy_test_cycle_failed:
    "Copying of the test cycle failed due to a technical error, we have been notified of this issue. Please contact support.",
  message: "Message",
  type_to_search: "Type to search",
  download: "Downloaden",
  create_new: "New",
  more_than_one_test_cycle_selected_for_removal:
    "Please select only one test cycle to remove.",
  are_you_sure_you_want_to_disconnect_from_test_run:
    "Are you sure you want to disconnect the defect from the testrun?",
  dialog_disconnect: "Disconnect from test run",
  dialog_api_changes_confirm_import:
    "Are you sure you want to create the selected changes as requirements in test cycle",
  dialog_api_changes_title: "Create changes as requirements",
  importing_selected_topdesk_operator_changes:
    "Importing the selected TOPdesk changes.<br />This may take a while...",
  my_list: "Mijn lijst",
  color_for_range_item_cannot_be_changed:
    "The color for this value cannot be changed.",
  go_to: "Go to",
  go_to_my: "Go to my",
  with: "with",
  release_mouse_button_to_place_here:
    "Let go of your mouse button to place here",
  functionality_not_available_in_free:
    "Paid functionality, click for more information.",
  functionality_not_available_in_paid:
    "Premium functionality, click for more information.",
  number_of_defects: "Number of defects",
  status_to: "Status to",
  back_to_months: "Back to months",
  number_of_status_transitions: "Number of status transitions",
  dialog_creating_environment_title: "New environment",
  dialog_creating_environment_message:
    "Creating an environment.<br />This may take a while...",
  save_and_send_explanation:
    "If this checkbox is checked, an email with login details will be sent to the user upon saving (Unavailable for users with type 'Dummy').",
  group_testrun_emails_tooltip:
    "When a user's testrun execution starts at a certain date, the user will receive an email for every testrun.<br /> When this setting is checked, the emails are combined per testcycle",
  import_module_download_example: "Download example",
  change_subsription: "Change subscription",
  change_subsription_message:
    "Are you sure you want to change the subscription? Already paid costs will be settled with the new subscription.",
  add_testcase_steps_to_export_question:
    "Would you like to add the steps of the testcases to the export?",
  export_to_excel: "Export to Excel",
  add_testcases_to_export_question:
    "Would you like to add the testcases in the testruns to the export?",
  export_testcase_steps: "Testcase stappen exporteren",
  export_markdown: "Opmaak exporteren",
  editor_not_available_in_current_browser:
    "Unfortunately, our markup editor is not available in your current browser. You can add markup as following:<br /><br />",
  markdown_explanation_1: "<ul><li>Bold: **text**</li>",
  markdown_explanation_2: "<li>Cursive: text</li>",
  markdown_explanation_3: "<li>Strikethrough: ~~text~~</li>",
  markdown_explanation_4: "<li>Bulleted list: * first item * second item</li>",
  markdown_explanation_5:
    "<li>Numbered list: 1. first item 2. second item</li>",
  markdown_explanation_6:
    "<li>Text link: [text](http://www.example.com)</li></ul>",
  add_user_to_environment_explanation:
    "If this checkbox is enabled, you will be automatically added to the environment with the role Manager.<br/>When an existing environment is modified, the checkbox is not shown.",
  schedule_test_runs: "Schedule test runs",
  collapse_tree: "Collapse tree",
  expand_tree: "Expand tree",
  hide_requirements: "Hide requirements",
  show_requirements: "Show requirements",
  are_you_sure_you_want_to_reset_mytaks_tiles:
    "Are you sure you want to reset your tasks to the default tasks for your role?",
  entity_testcases: "test case(s)",
  entity_testscenarios: "test scenario(s)",
  entity_products: "product(s)",
  entity_requirements: "requirement(s)",
  entity_testruns: "testrun(s)",
  entity_testcycles: "test cycle(s)",
  entity_environmentusers: "user(s)",
  entity_customerusers: "user(s)",
  entity_users: "user(s)",
  entity_groups: "group(s)",
  entity_defects: "defect(s)",
  menu_weergeven: "Show menu",
  menu_verbergen: "Hide menu",
  product_search: "Search product",
  copy: "Copy",
  copy_test_cycle_confirmation_text: function (entityPrefixedId) {
    return "You are going to copy TST" + entityPrefixedId + ". Do you want to continue?";
  },
  product_requirement_search: "Search for product / requirement",
  task_tiles_configuration_requirement_title: "Tasks for requirements",
  task_tiles_configuration_defect_title: "Tasks for defects",
  task_tiles_configuration_product_title: "Tasks for products",
  task_tiles_configuration_testscenario_title: "Tasks for test scenarios",
  task_tiles_configuration_testcase_title: "Tasks for test cases",
  remove_task: "Are you sure you want to remove this task?",
  email_login_message_with_vars: function (amount, entity) {
    return "Are you sure you want to send login data to " + amount + " " + entity + "?";
  },
  delete_message_with_vars: function (amount, entity) {
    return "Are you sure you want to delete " + amount + " " + entity + "?";
  },
  archive_message_with_vars: function (amount, entity) {
    return "Are you sure you want to archive " + amount + " " + entity + "?";
  },
  unarchive_message_with_vars: function (amount, entity) {
    return "Are you sure you want to unarchive " + amount + " " + entity + "?";
  },
  bulk_edit_confirm_with_vars: function (amount, entity) {
    return (
      "Are you sure you want to execute the bulk edit for " +
      amount +
      " " +
      entity +
      "?"
    );
  },
  move_confirm_with_vars: function (amount, entity) {
    return "Are you sure you want to move " + amount + " " + entity + "to ";
  },
  schedule_confirm_with_vars: function (amount, entity) {
    return (
      "Are you sure you want to execute the edit for" +
      amount +
      " " +
      entity +
      "?"
    );
  },
  all_available_tiles_are_already_present:
    "All available tasks are already present",

  maximum_user_amount_exceeded_title: "Batch edit not possible",
  maximum_user_amount_exceeded_message:
    "The batch edit can not be executed, because the maximum amount of active users will be exceeded",
  a_problem_has_occured_please_try_again:
    "A problem has occurred. Please try again.",
  imagesize_is_too_large_to_edit: function (maxEditableFileSizeText) {
    return (
      "This attachment is too large (maximum of " +
      maxEditableFileSizeText +
      ") to edit"
    );
  },
  filesize_is_too_large_to_upload: function (maxEditableFileSizeText) {
    return (
      "This attachment is too large to upload (maximum of " +
      maxEditableFileSizeText +
      ")"
    );
  },
  error_saving_user_settings:
    "Something went wrong while saving the settings. Please try again",

  edit_test_case_in_test_run: function (testrun) {
    return `The test case is is not yet started in the following test run: <br><br>${testrun}<br><br>Do you also want to implement the changes in this test run?`;
  },
  edit_test_case_in_test_runs: function (testruns) {
    return `<p>The test case is not yet started in ${
      testruns.length
    } test runs (<span class="show-more open">show test runs</span>)<br>
        <ul class="testruns-with-testcase">${testruns.join("")}</ul>      
        Do you also want to implement the changes in these test runs?</p>`
  },
  show_testruns: "show test runs",
  hide_testruns: "hide test runs",
  edit_testcase: "Edit test case",
  test_run_test_case_status_to_ok: "Change test case status",
  test_run_test_case_status_to_ok_message: function (notPerformedStepsCount) {
    return (
      (notPerformedStepsCount > 1
        ? notPerformedStepsCount + " test steps that are not performed yet"
        : notPerformedStepsCount + " test step that is not performed yet") +
      " will get the status OK. Are you sure you would like to continue?"
    );
  },
  integration: "Integration",
  integrations: "Integrations",
};
